import { render } from "./IpPortAccessModal.vue?vue&type=template&id=e4036d16"
import script from "./IpPortAccessModal.vue?vue&type=script&lang=js"
export * from "./IpPortAccessModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__